const HonourStarIcon = ({size}) => {
  const width = size ? size : "21"
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.1875 2.73828L18.8125 2.73828"
        stroke="#CD7F32"
        stroke-width="0.967742"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.9375 2.73828V12.3624C3.9375 14.4001 4.31426 15.0656 6.06158 16.114L8.69926 17.6966C9.5766 18.223 10.0153 18.4862 10.5 18.4862C10.9847 18.4862 11.4234 18.223 12.3007 17.6966L14.9384 16.114C16.6857 15.0656 17.0625 14.4001 17.0625 12.3624V2.73828"
        stroke="#CD7F32"
        stroke-width="0.967742"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.0289 7.11806L11.5678 8.20485C11.6413 8.35614 11.8373 8.50125 12.0027 8.52903L12.9795 8.69267C13.6042 8.79764 13.7512 9.25459 13.301 9.70536L12.5416 10.471C12.413 10.6007 12.3426 10.8508 12.3824 11.0299L12.5998 11.9777C12.7713 12.728 12.3763 13.0182 11.7179 12.6261L10.8023 12.0796C10.6369 11.9808 10.3644 11.9808 10.196 12.0796L9.28041 12.6261C8.6251 13.0182 8.22702 12.7249 8.3985 11.9777L8.61592 11.0299C8.65573 10.8508 8.5853 10.6007 8.45669 10.471L7.69727 9.70536C7.25019 9.25459 7.39412 8.79764 8.0188 8.69267L8.99563 8.52903C9.15792 8.50125 9.3539 8.35614 9.42739 8.20485L9.96633 7.11806C10.2603 6.52835 10.738 6.52835 11.0289 7.11806Z"
        stroke="#CD7F32"
        stroke-width="0.967742"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default HonourStarIcon;
